import React from 'react';
import AnalyticsChart from '../AnalyticsChart';
import { styles } from '../Analytics/styles';
import { CircularProgress, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { sumTotals } from '../../utils';
import { bindActionCreators, compose } from 'redux';
import { updateRange } from '../../stores/admin/actions';
import { analyticsDataRequested, analyticsExportRequested } from '../../stores/analytics/actions';
import { connect } from 'react-redux';
import { DOWNLOADS } from '../../constants/analytics';
import { getDownloadsContext, getDownloadsData, getRange } from '../../selectors/analytics';
import { getDownloadsChartData } from '../../selectors/adminDashboard';
import SoftProAdminDataTable from '../SoftProDataTable/SoftProAdminDataTable';
import { ExportButton } from '../ExportButton';
import { getAvailableStatesForDataTableFilter } from '../../selectors/states';
import { getAvailableUnderwritersForDataTableFilter } from '../../selectors/underwriters';
import PropTypes from 'prop-types';
import TablesPropTypes from '../../propTypes/tables';

const DownloadsChart = (props) => {
    const { data, range } = props;
    return (
        <div>
            <AnalyticsChart
                data={ data }
                headerText="Downloads"
                range={ range }
                headerCount={ sumTotals(data) }
            />
        </div>
    );
};

DownloadsChart.propTypes = {
    data: TablesPropTypes.tablePageData.isRequired,
    range: PropTypes.number.isRequired,
};

class DownloadsTabContent extends React.Component {
    componentDidMount () {
        const { analyticsDataRequested } = this.props;
        analyticsDataRequested(DOWNLOADS);
    }

    render () {
        const {
            classes,
            range,
            data,
            counts,
            analyticsDataRequested,
            context,
            tableDataLoading,
            chartDataLoading,
            availableStatesForDataTableFilter,
            availableUnderwritersForDataTableFilter,
            analyticsExportRequested,
        } = this.props;
        return (
            <div className={ classes.topGrid }>
                <Grid container spacing={ 8 } direction="column">
                    <Grid item>
                        {chartDataLoading
                            ? <CircularProgress />
                            : <DownloadsChart range={ range } data={ counts } />}
                    </Grid>
                    <Grid item>
                        <SoftProAdminDataTable
                            dataType={ DOWNLOADS }
                            hasNumberOfDownloadsColumn
                            tableData={ data }
                            tableContext={ context }
                            onFetchDataRequested={ analyticsDataRequested }
                            availableStatesForDataTableFilter={ availableStatesForDataTableFilter }
                            hasUnderwriterColumn
                            availableUnderwritersForDataTableFilter={ availableUnderwritersForDataTableFilter }
                            viewPath={ '/admin/downloads/package/' }
                        />
                    </Grid>
                    <Grid item>
                        <ExportButton
                            loading={ tableDataLoading }
                            onClick={ () => analyticsExportRequested(DOWNLOADS, context) }
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

DownloadsTabContent.propTypes = {
    range: PropTypes.number.isRequired,
    data: TablesPropTypes.tablePageData.isRequired,
    context: PropTypes.object.isRequired,
    counts: PropTypes.array.isRequired,
    tableDataLoading: PropTypes.bool.isRequired,
    chartDataLoading: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    analyticsDataRequested: PropTypes.func.isRequired,
    availableStatesForDataTableFilter: PropTypes.arrayOf(PropTypes.object).isRequired,
    availableUnderwritersForDataTableFilter: PropTypes.arrayOf(PropTypes.object).isRequired,
    analyticsExportRequested: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        range: getRange(state),
        counts: getDownloadsChartData(state),
        data: getDownloadsData(state),
        context: getDownloadsContext(state),
        tableDataLoading: state.analytics.downloads.loading,
        chartDataLoading: state.adminDashboardData.loading,
        availableStatesForDataTableFilter: getAvailableStatesForDataTableFilter(state),
        availableUnderwritersForDataTableFilter: getAvailableUnderwritersForDataTableFilter(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...(bindActionCreators({
            updateRange,
            analyticsDataRequested,
            analyticsExportRequested,
        }, dispatch)),
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
)(DownloadsTabContent);
